// extracted by mini-css-extract-plugin
export default {"AnnouncementBar":"AnnouncementBar_AnnouncementBar__5BViN","AnnouncementBar_inner":"AnnouncementBar_AnnouncementBar_inner__dV3uK"};